import { useResearchQuota } from "../context/QuotaContext";

// Abaixo deste saldo restante, o indicador muda para a cor de alerta.
const QUOTA_LOW_REMAINING_THRESHOLD = 3;

interface Props {
  variant?: "badge" | "notice";
}

export default function QuotaNotice({ variant = "badge" }: Props) {
  const { quota } = useResearchQuota();

  if (!quota || quota.exempt) return null;
  if (quota.daily.limit === null && !quota.blocked_by) return null;

  if (variant === "notice") {
    if (!quota.blocked_by) return null;

    const window = quota[quota.blocked_by];
    const title =
      quota.blocked_by === "daily"
        ? "Cota diária de pesquisas atingida"
        : "Cota mensal de pesquisas atingida";
    const resetLabel = new Intl.DateTimeFormat("pt-BR", {
      dateStyle: "short",
      timeStyle: "short",
    }).format(new Date(window.resets_at));

    return (
      <div
        role="alert"
        className="rounded-xl border border-red-300/60 bg-red-50/80 px-4 py-3 font-body"
      >
        <p className="text-sm font-semibold text-red-700">{title}</p>
        <p className="text-sm text-red-600 mt-1">Libera em {resetLabel}.</p>
      </div>
    );
  }

  const { daily } = quota;
  const isLow = daily.remaining !== null && daily.remaining <= QUOTA_LOW_REMAINING_THRESHOLD;
  const limitLabel = daily.limit === null ? "∞" : String(daily.limit);
  const label = isLow
    ? `Restam ${daily.remaining} pesquisas hoje`
    : `Pesquisas hoje: ${daily.used}/${limitLabel}`;

  return (
    <span
      role="status"
      className={`inline-flex items-center rounded-full border px-3 py-1.5 font-body text-xs font-medium whitespace-nowrap ${
        isLow
          ? "border-red-300/60 bg-red-50/80 text-red-600"
          : "glass-subtle border-ink-800/60 text-ink-400"
      }`}
    >
      {label}
    </span>
  );
}
